import { Tooltip } from "@progress/kendo-react-tooltip";
import DetailItem, { IDetailItem } from "../../utilities/DetailItem";

type Props = {
  details?: IDetailItem[];
};

export const QuoteDetailsSubHeader = ({ details }: Props) => {
  return (
    <Tooltip anchorElement="target" position="auto" showCallout={false}>
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        {details?.map((d, index) => {
          return (
            <div key={index}>
              <DetailItem {...d} />
            </div>
          );
        })}
      </div>
    </Tooltip>
  );
};
